import * as Sentry from '@sentry/react';

function ErrorFallback({ error, resetError }: { error: Error; resetError: () => void }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h1>
        <p className="text-gray-600 mb-4">We're sorry, but something unexpected happened.</p>
        <details className="mb-4">
          <summary className="cursor-pointer text-sm text-gray-500">Technical details</summary>
          <pre className="mt-2 text-xs bg-gray-100 p-2 rounded overflow-auto">{error.message}</pre>
        </details>
        <div className="flex gap-4">
          <button
            onClick={resetError}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Try again
          </button>
          <button
            onClick={() => window.location.href = '/'}
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300"
          >
            Go home
          </button>
        </div>
      </div>
    </div>
  );
}

export const SentryErrorBoundary = Sentry.withErrorBoundary(
  ({ children }: { children: React.ReactNode }) => <>{children}</>,
  {
    fallback: ({ error, resetError }: { error: Error; resetError: () => void }) => (
      <ErrorFallback error={error} resetError={resetError} />
    ),
    showDialog: false,
  }
);

export function useCaptureException() {
  return (error: Error, context?: Record<string, unknown>) => {
    Sentry.captureException(error, { extra: context });
  };
}
